/* eslint-disable no-case-declarations */
/* eslint-disable default-param-last */
import { actions, types } from './actions'
import { sortLeaderboard, calculateBonus, mapGoalAmount, calculateGoalPercentage, getDefaultSort } from './functions'

const initialState: LeaderboardState = {}

export const reducer = (state: LeaderboardState = initialState, action: ActionsUnion<typeof actions>): LeaderboardState => {
    switch (action.type) {
        case types.ASSIGN_LEADERBOARD_SETTINGS:
            const payload = action.payload
            return {
                ...state,
                instanceSettings: payload as LeaderboardSettingsDto,
            }
        case types.POPULATE_LEADERBOARD_DATA:
        case types.POPULATE_LEADERBOARDAMBASSADOR_DATA:
            const data: ApiLeaderboardDataRecord[] = action.payload
            const defaultSort = getDefaultSort((state.instanceSettings?.layoutSettings.defaultAutoSort) ? (state.instanceSettings?.layoutSettings.defaultAutoSort) : 'Dollars', (state.instanceSettings?.scoreboardTypeId) ? (state.instanceSettings?.scoreboardTypeId) : 0)
            const sort = state.sort
                ? { ...state.sort }
                : defaultSort
            const rankedData = data.sort(sortLeaderboard(defaultSort)).map((record, i) => ({ ...record, rank: i + 1 }))
            const calculatedBonus = calculateBonus(rankedData,
                state.instanceSettings!.layoutSettings.bonusAmount,
                state.instanceSettings!.layoutSettings.distributionType,
                state.instanceSettings!.layoutSettings.displayBonusAmount,
                state.instanceSettings!.layoutSettings.distributionMethodType,
                state.instanceSettings!.layoutSettings.rankedDistribution!,
                state.instanceSettings!.layoutSettings.numberOfRanks)
            const mappedGoalAmount = mapGoalAmount(calculatedBonus,
                state.instanceSettings!.layoutSettings.enableGoals,
                state.instanceSettings!.layoutSettings.displayGoals,
                state.instanceSettings!.layoutSettings.displayPercentageOfGoals,
                state.instanceSettings!.layoutSettings.goals!)
            const calculatedGoalPercentage = calculateGoalPercentage(mappedGoalAmount,
                state.instanceSettings!.layoutSettings.enableGoals,
                state.instanceSettings!.layoutSettings.displayPercentageOfGoals,
                state.instanceSettings!.layoutSettings.defaultGoals,
                state.instanceSettings!.layoutSettings.enableGoalTracking)
            // Ranking of data happens through - Dollars/Participation/Percentage of Goal
            // During the first ranking, Percentage of Goal is not calculated yet and hence data can be ranked based only on Dollars/Participation
            // Without disrupting the existing logic which uses the ranked data, we're simply re-ranking it post the calculation of percentageOfGoal.
            const displayData = calculatedGoalPercentage.sort(sortLeaderboard(sort)).map((calculatedGoalPercentage, i) => ({ ...calculatedGoalPercentage, rank: i + 1 }))
            return {
                ...state,
                sort,
                data: displayData,
            }
        case types.TOGGLE_OVERRIDE_DISPLAY_LIMIT:
            return {
                ...state,
                overrideDisplayLimit: !state.overrideDisplayLimit,
            }
        case types.SORT_LEADERBOARD:
            return {
                ...state,
                sort: action.payload,
            }
        default:
            return state
    }
}
